<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row mb-2">
                    <h1 class="col-md-12 text-center">Franchisee Bills</h1>
                </div>

                <div class="row  mt-2">

                    <div class="col-md-2 " v-if="authenticatedUser.permissions.includes('super') ">
                        <b-input v-model="searchBillRef"
                                 @input="debouncedSearch"
                                 placeholder="Search by Bill Ref#"></b-input>
                    </div>

                    <div class="col-md-2" v-if="authenticatedUser.permissions.includes('super')">
                        <b-form-select v-model="filterStatus"
                                       @change="onFilterChange"
                                       :options="statusOptions">
                            <template #first>
                                <b-form-select-option :value="''" disabled>-- Filter by Status --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div class="col-md-2" v-if="authenticatedUser.permissions.includes('super')">
                        <b-form-select v-model="filterFranchiseeId"
                                       @change="onFilterChange"
                                       :options="franchiseeOptions">
                            <template #first>
                                <b-form-select-option :value="''" disabled>-- Filter by Franchisee --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="bills?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="bills?.to-50>0">{{bills?.to-50}}</span> <span v-else="">0</span>  to {{bills.to}}) out of {{bills.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="bills?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                 <div class="col-md-12">
                     <table class="table table-bordered table-striped text-light">
                         <thead class="thead-dark">
                         <tr>

                             <th>ID</th>
                             <th>Bill Ref#</th>
                             <th>Franchisee</th>
<!--                             <th>Branch ID</th>-->
                             <th>Bill Date</th>
                             <th>Due Date</th>

                             <th>SubTotal</th>
                             <th>VAT</th>
                             <th>Grand Total</th>
                             <th>Total Paid</th>
                             <th>Status</th>
                             <th class="text-center">Actions</th>
                         </tr>
                         </thead>
                         <tbody >
                         <template v-for="bill in bills.data">
                             <tr>
                                 <td>{{bill.id}}</td>
                                 <td>{{bill.bill_ref}}</td>
                                 <td>{{bill.franchisee ? bill.franchisee.f_name : ''}}</td>
<!--                                 <td>{{bill.branch_id}}</td>-->
                                 <td>{{formatDate(bill.bill_created_at)}}</td>
                                 <td>{{formatDate(bill.dueDate)}}</td>

                                 <td>{{bill.subTotal}}</td>
                                 <td>{{bill.vat}}</td>
                                 <td>{{bill.grandTotal}}</td>
                                 <td>{{bill.totalPaid}}</td>
                                 <td>{{bill.status}}</td>
                                 <td class="text-center">
                                     <b-button @click="loadBill(bill.id)" class="btn-info mb-1"> Load </b-button>
                                 </td>
                             </tr>
                         </template>

                         </tbody>
                     </table>
                 </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import {cloneDeep} from "lodash";
import debounce from "lodash/debounce";
import moment from "moment/moment";


export default {
    name: "franchisee bills",

    components:{Loader, Welcomenote, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        ...mapState('franchiseeBills',['bill_filters','bills']),
        ...mapState('franchisees',['franchisees']),
        totalPages() {
            const perpage = this.bills.per_page;
            const total=this.bills.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },

        franchiseeOptions() {
            if (!this.allFranchisees || !this.allFranchisees.length) return [];
            return this.allFranchisees.map(f => ({
                value: f.id,
                text: f.f_name
            }));
        },

    },
    data() {
        return {
            saving:false,
            showloader:false,
            searchBillRef:'',
            filterStatus:'',
            filterFranchiseeId:'',
            allFranchisees:[],
            statusOptions: [
                { value: 'Draft', text: 'Draft' },
                { value: 'Pending', text: 'Pending' },
                { value: 'Unpaid', text: 'Unpaid' },
                { value: 'Overdue', text: 'Overdue' },
                { value: 'Paid', text: 'Paid' },
            ],
        };
    },
    async created() {
        this.searchBillRef = this.bill_filters.bill_ref;
        this.filterStatus = this.bill_filters.status;
        this.filterFranchiseeId = this.bill_filters.franchisee_id;
        this.showloader=true
        await this.loadAllFranchisees();
        await this.get_bills();
        this.showloader=false

    },
    async mounted() {

    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('franchiseeBills', ['set_bills','get_bills']),

        async loadAllFranchisees() {
            const apiToken = localStorage.getItem('token');
            const url = `${URL.BASEURL}/api/get-franchisees`;
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify({ page: 1, name: '' })
                });
                if (response.ok) {
                    const res = await response.json();
                    this.allFranchisees = res.data || [];
                }
            } catch (error) {
                console.error('Error fetching franchisees:', error);
            }
        },

        debouncedSearch: debounce(function () {
            this.bill_filters.bill_ref = this.searchBillRef;
            this.bill_filters.page = 1;
            this.showloader = true;
            this.get_bills().finally(() => {
                this.showloader = false;
            });
        }, 500),

        onFilterChange() {
            this.bill_filters.status = this.filterStatus;
            this.bill_filters.franchisee_id = this.filterFranchiseeId;
            this.bill_filters.page = 1;
            this.showloader = true;
            this.get_bills().finally(() => {
                this.showloader = false;
            });
        },

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },

        formatDate(date){
            if (!date) return '';
            let date1 = new Date(date)
            return moment(date1).format('D MMMM, YYYY');
        },
        loadBill(id){
            this.$router.push({ path: '/franchisee-bill-details', query: { id: id } });
        },

        async get_paged_data(button){
            let current_page= this.bills.current_page
            this.bill_filters.page=current_page

            if(button=='next'){
                this.bill_filters.page=current_page+1
                await this.get_bills()
            }
            if(button=='prev'){
                this.bill_filters.page=current_page-1
                await this.get_bills()
            }
        },

    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}

</style>
